import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const liveMissionInBulkAction = createAsyncThunk(
    'live-mission-in-bulk',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/live-mission-in-bulk`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const liveMissionInBulkSlice = createSlice({
    name: 'live-mission-in-bulk',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(liveMissionInBulkAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(liveMissionInBulkAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(liveMissionInBulkAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const liveMissionInBulkReducer = liveMissionInBulkSlice.reducer    